export default "__VITE_ASSET__CB2Sedmc__"